import React, { Component } from 'react';
import { connect } from 'react-redux';

import Aux from '../Auxiliary/Auxiliary';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import Sidedrawer from '../../components/Navigation/Sidedrawer/Sidedrawer';
import NotificationHolder from '../../components/UI/NotificationHolder/NotificationHolder';
import NewTrip from '../../components/UI/NewTrip/NewTrip';
import NewRequest from '../../components/UI/NewRequest/NewRequest';
import NewCarrier from '../../components/UI/NewCarrier/NewCarrier';
import DriverModal from '../../components/DriverModal/DriverModal';
import NewRequestLink from '../../components/UI/NewRequestLink/NewRequestLink';
import popSound from '../../assets/audio/pop.mp3';
import logError from '../../store/LogError';
import Loader from '../../components/Loader/Loader';
import axios from '../../axios-trips';
import classes from './Layout.css';
import qs from 'qs';
import * as actionTypes from '../../store/actions';
import { withRouter } from 'react-router-dom'
import packageJson from '../../package.alias.json'

class Layout extends Component {

  state = {
    showSideDrawer: false,
    update: null,
    reauthenticating: false,
    managerNameCounter: 0,
    reauthCount: 0
  }

  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: false })
  }

  sideDrawerToggleHandler = () => {
    this.setState((prevState) => {
      return { showSideDrawer: !prevState.showSideDrawer }
    });
  }

  getExternalNotifications() {
    axios({
      method: 'get',
      url: '/api/v1/notifications',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        let externalNotifications = {};
        for (let i = 0; i < response.data.length; i++) {
          if (!(response.data[i].id in externalNotifications)) {
            externalNotifications[response.data[i].id] = response.data[i];
          }
        }
        let same = true;
        let oldKeys = Object.keys(this.props.externalNotifications);
        let newKeys = Object.keys(externalNotifications);
        if (oldKeys.length !== newKeys.length) {
          same = false;
        } else {
          for (let i = 0; i < oldKeys.length; i++) {
            let index = newKeys.indexOf(oldKeys[i]);
            if (index > -1) {
              same = same && this.props.externalNotifications[oldKeys[i]].notificationType === externalNotifications[newKeys[index]].notificationType;
            } else {
              same = false;
            }
          }
          if (!same) {
            for (let i = 0; i < newKeys.length; i++) {
              let index = oldKeys.indexOf(newKeys[i]);
              if (index > -1) {
                same = same && externalNotifications[newKeys[i]].notificationType === this.props.externalNotifications[oldKeys[index]].notificationType;
              } else {
                same = false;
              }
            }
          }
        }

        if (!same) {
          this.props.onSetExternalNotifications(externalNotifications);
          new Audio(popSound).play();
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    if ((this.props.history.location.pathname === '/new-request' || this.props.history.location.pathname === '/trip-tracking/tracking') &&
      (query.get("token") || query.get("trTk"))) {
      return;
    }

    if (localStorage.getItem("access_token") !== null && localStorage.getItem("refresh_token") !== null && !this.props.authenticated) {
      localStorage.setItem("name", localStorage.getItem("name"));
      const loginDetails = {
        "grant_type": "refresh_token",
        "refresh_token": localStorage.getItem("refresh_token"),
      };

      axios({
        method: 'get',
        url: '/api/v1/trip-last-change',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem("access_token") },
      })
        .then(response => {
          this.props.onAuthenticated(localStorage.getItem("access_token"), localStorage.getItem("refresh_token"), localStorage.getItem("name"));
        })
        .catch(error => {
          console.log(error);
          if (error.response && error.response.data.error_description === "User account is locked") {
            this.props.addNotification("Ошибка: Учетная запись заблокирована. Обратитесь к администратору сайта.", "Danger");
            logError(
              this.props.access_token,
              "Ошибка: Учетная запись заблокирована. Обратитесь к администратору сайта.",
              '/api/v1/trip-last-change'
            );
            this.props.history.push('/account');
          } else if (error.response && error.response.status === 401) {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("name");
            this.props.onSetManagerName(null);
            this.props.onLogout();
            this.setState({ reauthenticating: false });
            this.props.history.push('/account');
          } else if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/trip-last-change'
            );
            this.props.history.push('/account');
          } else if (!error.response) {
            window.location.reload(false);
          }
        });
    } else {
      if (this.props.location !== "/account") {
        this.props.history.push('/account');
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.authenticated && this.props.authenticated) {
      axios({
        method: 'get',
        url: '/api/v1/signup/role',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          this.props.onSetRole(response.data);
          if (response.data === "ROLE_MANAGER" || response.data === "ROLE_RULER" || response.data === "ROLE_ADMIN") {
            this.findManagerName();
          }
          this.getLocations();
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/signup/role'
            );
          }
        });
    } else if (this.props.access_token === null &&
      (this.props.history.location.pathname !== "/new-request" ||
        this.props.history.location.pathname !== "/trip-tracking/tracking")) {
      this.props.onSetRole("ROLE_GUEST");
      if (prevProps.access_token !== null) {
        this.props.history.push('/account');
      }
    }

    if (!prevProps.authenticated && this.props.authenticated) {
      if (this.updatesTimer) {
        clearInterval(this.updatesTimer);
      }
      this.updatesTimer = setInterval(() => this.getUpdates(), 3000);
    } else if (prevProps.authenticated && !this.props.authenticated) {
      if (this.updatesTimer) {
        clearInterval(this.updatesTimer);
      }
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.updatesTimer) {
      clearInterval(this.updatesTimer);
    }
  }

  compareVersion(v1, v2) {
    let arr1 = v1.split(".");
    let arr2 = v2.split(".");
    let n = arr1.length;
    let m = arr2.length;
    for (let i = 0; i < n; i++) {
      arr1[i] = parseInt(arr1[i]);
    }
    for (let i = 0; i < m; i++) {
      arr2[i] = parseInt(arr2[i]);
    }

    if (n > m) {
      for (let i = m; i < n; i++) {
        arr2.push(0);
      }
    } else if (m > n) {
      for (let i = n; i < m; i++) {
        arr1.push(0);
      }
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] > arr2[i]) {
        return 1;
      } else if (arr1[i] < arr2[i]) {
        return 0;
      }
    }

    return 0;
  }

  getUpdates() {
    axios({
      method: 'get',
      url: '/api/v1/frontend-version',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        if (this.compareVersion(response.data, packageJson.version)) {
          window.location.reload(false);
        }
      })
      .catch(error => {
        console.log(error.response);
        if (error.response && error.response.status === 401 && !this.state.reauthenticating) {
          this.setState({ reauthenticating: true, reauthCount: this.state.reauthCount + 1 });
          if (this.state.reauthCount >= 5) {
            this.props.onLogout();
            this.props.addNotification("Щось пішло не так. Переконайтеся, що ви не залогінені в інших вікнах", "Danger");
          }
          setTimeout(() => this.setState({ reauthCount: this.state.reauthCount - 1 }), 15000);
          this.reAuthenticate();
        } else if (error.response && error.response.status) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/frontend-version'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });

    axios({
      method: 'get',
      url: '/api/v1/trip-last-change',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        if (this.state.update < response.data || this.state.update == null) {
          if (this.state.update !== null) {
            this.getTripsChanges(this.state.update);
          }
        }
        this.setState({ update: response.data });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response && error.response.status === 401 && !this.state.reauthenticating) {
          this.setState({ reauthenticating: true, reauthCount: this.state.reauthCount + 1 });
          if (this.state.reauthCount >= 5) {
            this.props.addNotification("Щось пішло не так. Переконайтеся, що ви не залогінені в інших вікнах", "Danger");
          }
          setTimeout(() => this.setState({ reauthCount: this.state.reauthCount - 1 }), 15000);
          this.reAuthenticate();
        } else if (error.response && error.response.status) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trip-last-change'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  findManagerName() {
    axios({
      method: 'get',
      url: '/api/v1/managers/username',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        if (response.data) {
          this.props.onSetManagerName(response.data.name);
          this.props.onSetManagerId(response.data.id);
        }
      })
      .catch(error => {
        console.log(error.response);
        if (error.response && error.response.status === 401 && !this.state.reauthenticating) {

        } else if (error.response && error.response.status) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/managers/username'
          );
          if (error.response.status === 403 && this.state.managerNameCounter < 5) {
            this.setState({ managerNameCounter: this.state.managerNameCounter + 1 });
            setTimeout(() => this.findManagerName(), 1000);
            this.reAuthenticate();
            return;
          }
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  getLocations() {
    axios({
      method: 'get',
      url: '/api/v1/locations',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.props.onSetLocations(response.data);
        if (!this.props.routes || this.props.routes.length === 0) {
          this.getTrips();
        }
        if (!this.props.requests || this.props.requests.length === 0) {
          this.getRequests();
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response && error.response.status) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/locations'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  getTrips() {
    axios({
      method: 'get',
      url: '/api/v1/trips',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.props.onSetRoutes(response.data);
        this.getExternalNotifications();
        if (this.props.role === "ROLE_ADMIN" || this.props.role === "ROLE_DISPATCHER") {
          if (!this.timer) {
            this.timer = setInterval(() => this.getExternalNotifications(), 7500);
          }
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  getTripsChanges(updatedTime) {
    axios({
      method: 'post',
      url: '/api/v1/trips/changed',
      data: { lastChangeDate: updatedTime },
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedRoutes = [...this.props.routes];
        const updatedRequests = [...this.props.requests];
        const updatedTripHistory = { ...this.props.tripCarrierHistory };
        let routesUpdated = false;
        let requestsUpdated = false;
        let tripCarrierHistoryUpdated = false;
        let selectedTripId = this.props.selectedTrip ? parseInt(this.props.selectedTrip.id.substring(1, this.props.selectedTrip.id.length), 10) : null;
        let selectedRequestId = this.props.selectedRequest ? parseInt(this.props.selectedRequest.id.substring(1, this.props.selectedRequest.id.length), 10) : null;
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].event === "Trip") {
            for (let j = 0; j < updatedRoutes.length; j++) {
              if (response.data[i].eventType === "DELETE") {
                if (updatedRoutes[j].id === response.data[i].updatedId) {
                  routesUpdated = true;
                  updatedRoutes.splice(j, 1);
                  j -= 1;
                  break;
                }
              } else if (response.data[i].eventType === "UPDATE") {
                if (parseInt(updatedRoutes[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                  routesUpdated = true;
                  if (selectedTripId === response.data[i].updatedId) {
                    const updatedSelectTrip = { ...this.props.selectedTrip };
                    updatedSelectTrip[response.data[i].eventDescription] = response.data[i].payloadObject;
                    this.props.onSelectTrip(updatedSelectTrip);
                  }
                  updatedRoutes[j][response.data[i].eventDescription] = response.data[i].payloadObject;
                  console.log("Set " + response.data[i].eventDescription + " to " + response.data[i].payloadObject);
                  break;
                }
              }
            }
            if (response.data[i].eventType === "ADD") {
              updatedRoutes.push(response.data[i].payloadObject);
              let objExists = false;
              for (let j = 0; j < updatedRoutes.length; j++) {
                if (parseInt(updatedRoutes[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                  objExists = true;
                  break;
                }
              }
              if (!objExists) {
                routesUpdated = true;
                updatedRoutes.push(response.data[i].payloadObject);
              }
            }
          } else if (response.data[i].event === "Request") {
            for (let j = 0; j < updatedRequests.length; j++) {
              if (response.data[i].eventType === "DELETE") {
                if (updatedRequests[j].id === response.data[i].updatedId) {
                  requestsUpdated = true;
                  updatedRequests.splice(j, 1);

                  if (selectedTripId) {
                    const updatedSelectTrip = { ...this.props.selectedTrip };
                    if (updatedSelectTrip.requests) {
                      const updatedRequests = [...updatedSelectTrip.requests];
                      for (let z = 0; z < updatedRequests.length; z++) {
                        if (parseInt(updatedRequests[z].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                          updatedRequests.splice(z, 1);
                          break;
                        }
                      }
                      updatedSelectTrip.requests = updatedRequests;
                      this.props.onSelectTrip(updatedSelectTrip);
                    }
                  }
                  j -= 1;
                  break;
                }
              } else if (response.data[i].eventType === "UPDATE") {
                if (parseInt(updatedRequests[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                  requestsUpdated = true;
                  if (selectedRequestId === response.data[i].updatedId) {
                    const updatedSelectRequest = { ...this.props.selectedRequest };
                    if (response.data[i].eventDescription === "requestTripDate") {
                      updatedSelectRequest[response.data[i].eventDescription] = response.data[i].payloadObject.substring(0, 10);
                    } else if (response.data[i].eventDescription === "moneyRequests" && !response.data[i].payloadObject) {
                      updatedSelectRequest[response.data[i].eventDescription] = [];
                    } else if (response.data[i].eventDescription === "managerMessageDate") {
                      let updatedData = response.data[i].payload;
                      updatedData = updatedData.substring(0, 10) + "T" + updatedData.substring(11, updatedData.length);
                      updatedSelectRequest[response.data[i].eventDescription] = updatedData;
                    } else {
                      updatedSelectRequest[response.data[i].eventDescription] = response.data[i].payloadObject;
                    }

                    this.props.onSelectRequest(updatedSelectRequest);
                  }

                  const updatedRequestInstance = { ...updatedRequests[j] };
                  if (response.data[i].eventDescription === "requestTripDate") {
                    updatedRequestInstance[response.data[i].eventDescription] = response.data[i].payloadObject.substring(0, 10);
                  } else if (response.data[i].eventDescription === "managerMessageDate") {
                    let updatedData = response.data[i].payload;
                    updatedData = updatedData.substring(0, 10) + "T" + updatedData.substring(11, updatedData.length);
                    updatedRequestInstance[response.data[i].eventDescription] = updatedData;
                  } else {
                    updatedRequestInstance[response.data[i].eventDescription] = response.data[i].payloadObject;
                  }
                  updatedRequests[j] = updatedRequestInstance;

                  if (selectedTripId) {
                    const updatedSelectTrip = { ...this.props.selectedTrip };
                    if (updatedSelectTrip.requests) {
                      const updatedRequests = [...updatedSelectTrip.requests];
                      for (let z = 0; z < updatedRequests.length; z++) {
                        if (parseInt(updatedRequests[z].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                          updatedRequests[z] = updatedRequestInstance;
                          break;
                        }
                      }
                      updatedSelectTrip.requests = updatedRequests;
                      this.props.onSelectTrip(updatedSelectTrip);
                    }
                  }

                  break;
                }
              }
            }
            if (response.data[i].eventType === "ADD") {
              let objExists = false;
              for (let j = 0; j < updatedRequests.length; j++) {
                if (parseInt(updatedRequests[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                  requestsUpdated = true;
                  objExists = true;
                  break;
                }
              }
              if (!objExists) {
                requestsUpdated = true;
                updatedRequests.push(response.data[i].payloadObject);
              }
            }
          } else if (response.data[i].event === "TripCarrierHistory") {
            if (updatedTripHistory) {
              if (response.data[i].eventType === "ADD") {
                if (updatedTripHistory.tripId === response.data[i].payloadObject.tripId) {
                  let objExists = false;
                  for (let j = 0; j < updatedTripHistory.history.length; j++) {
                    if (parseInt(updatedTripHistory.history[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                      tripCarrierHistoryUpdated = true;
                      objExists = true;
                      break;
                    }
                  }
                  if (!objExists) {
                    updatedTripHistory.history.unshift(response.data[i].payloadObject);
                  }
                }
              } else if (response.data[i].eventType === "UPDATE") {
                for (let j = 0; j < updatedTripHistory.history.length; j++) {
                  if (updatedTripHistory.history[j].id === response.data[i].updatedId) {
                    tripCarrierHistoryUpdated = true;
                    updatedTripHistory.history[j][response.data[i].eventDescription] = response.data[i].payloadObject;
                    break;
                  }
                }
              } else if (response.data[i].eventType === "DELETE") {
                for (let j = 0; j < updatedTripHistory.history.length; j++) {
                  if (updatedTripHistory.history[j].id === response.data[i].updatedId) {
                    tripCarrierHistoryUpdated = true;
                    updatedTripHistory.history.splice(j, 1);
                    break;
                  }
                }
              }
            }
          } else if (response.data[i].event === "TripPoint") {
            for (let j = 0; j < updatedRoutes.length; j++) {
              if (response.data[i].eventType === "DELETE") {
                if (updatedRoutes[j].id === response.data[i].updatedId) {
                  routesUpdated = true;
                  let tripPointIndex = -1;
                  for (let z = 0; z < updatedRoutes[j].tripPoints.length; z++) {
                    if (updatedRoutes[j].tripPoints[z] && updatedRoutes[j].tripPoints[z].id === parseInt(response.data[i].payload, 10)) {
                      tripPointIndex = z;
                      break;
                    }
                  }
                  if (tripPointIndex > -1) {
                    console.log("Deleting at id " + response.data[i].payload + " from object ", updatedRoutes[j]);
                    updatedRoutes[j].tripPoints.splice(tripPointIndex, 1);
                  }
                  break;
                }
              } else if (response.data[i].eventType === "UPDATE") {
                if (updatedRoutes[j].id === response.data[i].updatedId) {
                  routesUpdated = true;
                  if (updatedRoutes[j].id === parseInt(response.data[i].updatedId, 10)) {
                    updatedRoutes[j].tripPoints = response.data[i].payloadObject ? response.data[i].payloadObject : [];
                    console.log("Updated routes", updatedRoutes);
                    break;
                  }

                  if (selectedTripId) {
                    const updatedSelectTrip = { ...this.props.selectedTrip };
                    if (parseInt(updatedSelectTrip.id.substring(1, updatedSelectTrip.id.length), 10) === response.data[i].updatedId) {
                      for (let z = 0; z < updatedSelectTrip.tripPoints.length; z++) {
                        if (updatedSelectTrip.id === parseInt(response.data[i].updatedId, 10)) {
                          updatedSelectTrip.tripPoints = response.data[i].payloadObject ? response.data[i].payloadObject : [];
                          break;
                        }
                      }
                      this.props.onSelectTrip(updatedSelectTrip);
                    }
                  }

                  break;
                }
              }
            }
            if (response.data[i].eventType === "ADD") {
              let objExists = false;
              for (let j = 0; j < updatedRoutes.length; j++) {
                if (parseInt(updatedRoutes[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                  for (let z = 0; z < updatedRoutes[j].tripPoints.length; z++) {
                    if (updatedRoutes[j].tripPoints[z].id === parseInt(response.data[i].payload, 10)) {
                      objExists = true;
                      break;
                    }
                  }
                  break;
                }
              }

              if (!objExists) {
                routesUpdated = true;
                for (let j = 0; j < updatedRoutes.length; j++) {
                  if (parseInt(updatedRoutes[j].id, 10) === parseInt(response.data[i].updatedId, 10)) {
                    updatedRoutes[j].tripPoints.push({ ...response.data[i].payloadObject });
                  }
                }
              }
            }
          }
        }
        if (routesUpdated) {
          this.props.onSetRoutes(updatedRoutes);
        }
        if (requestsUpdated) {
          this.props.onSetRequests(updatedRequests);
        }
        if (tripCarrierHistoryUpdated) {
          this.props.onSetTripCarrierHistory(updatedTripHistory);
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips/changed'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  getRequests() {
    axios({
      method: 'get',
      url: '/api/v1/requests',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.props.onSetRequests(response.data);
      })
      .catch(error => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.getRequests();
        } else if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  reAuthenticate() {
    const loginDetails = {
      "grant_type": "refresh_token",
      "refresh_token": localStorage.getItem("refresh_token"),
    };

    axios({
      method: 'post',
      url: '/oauth/token',
      data: qs.stringify(loginDetails),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      auth: {
        username: "spring-security-oauth2-read-write-client",
        password: "spring-security-oauth2-read-write-client-password1234"
      }
    })
      .then(response => {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        this.props.onAuthenticated(response.data.access_token, response.data.refresh_token, localStorage.getItem("name"))
        console.log("Authenticated Successfully");
        this.setState({ reauthenticating: false });
      })
      .catch(error => {
        console.log(error);
        if (error.response && error.response.data.error_description === "User account is locked") {
          this.props.addNotification("Ошибка: Учетная запись заблокирована. Обратитесь к администратору сайта.", "Danger");
        }
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("name");
        this.props.onSetManagerName(null);
        this.props.onLogout();
        this.setState({ reauthenticating: false });
      });
  }

  render() {
    return (
      <Aux>
        {
          this.props.authenticated ||
            this.props.history.location.pathname === "/account" ||
            this.props.history.location.pathname === '/new-request' ||
            this.props.history.location.pathname === '/trip-tracking/tracking' ?
            <Aux>
              <Toolbar
                drawerToggleClicked={this.sideDrawerToggleHandler} />
              <Sidedrawer open={this.state.showSideDrawer} closed={this.sideDrawerClosedHandler} />
              <DriverModal />
              <NotificationHolder />
              <NewTrip
                show={this.props.showNewTrip}
                closeCard={() => this.props.onShowNewTrip(false)} />
              <NewRequest
                show={this.props.showNewRequest}
                closeCard={() => this.props.onShowNewRequest(false)} />
              <NewCarrier
                carrier={this.props.showNewCarrier}
                closeCard={() => this.props.onShowNewCarrier(null)} />
              <NewRequestLink />
              <main className={classes.Content}>
                {this.props.children}
              </main>
            </Aux>
            : <Loader message="Авторизуюся..." />
        }
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    name: state.name,
    authenticated: state.authenticated,
    access_token: state.access_token,
    showNewTrip: state.showNewTrip,
    showNewRequest: state.showNewRequest,
    showNewCarrier: state.showNewCarrier,
    requests: state.requests,
    routes: state.routes,
    managers: state.managers,
    carriers: state.carriers,
    role: state.role,
    users: state.users,
    locations: state.locations,
    selectedTrip: state.selectedTrip,
    selectedRequest: state.selectedRequest,
    externalNotifications: state.externalNotifications,
    codeToMessage: state.codeToMessage,
    tripCarrierHistory: state.tripCarrierHistory
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onSetManagerName: (managerName) => dispatch({
      type: actionTypes.MANAGER_NAME,
      managerName: managerName
    }),
    onSetManagerId: (managerId) => dispatch({
      type: actionTypes.MANAGER_ID,
      managerId: managerId
    }
    ),
    onSelectTrip: (selectedTrip) => dispatch({
      type: actionTypes.SELECT_TRIP,
      selectedTrip: selectedTrip
    }),
    onSelectRequest: (selectedRequest) => dispatch({
      type: actionTypes.SELECT_REQUEST,
      selectedRequest: selectedRequest
    }),
    onAuthenticated: (tokenValue, refreshValue, name) => dispatch({
      type: actionTypes.LOGIN,
      access_token: tokenValue,
      refresh_token: refreshValue,
      name: name
    }),
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onShowNewTrip: (showNewTrip) => dispatch({
      type: actionTypes.SHOW_NEW_TRIP,
      showNewTrip: showNewTrip
    }),
    onShowNewRequest: (showNewRequest) => dispatch({
      type: actionTypes.SHOW_NEW_REQUEST,
      showNewRequest: showNewRequest
    }),
    onShowNewCarrier: (showNewCarrier) => dispatch({
      type: actionTypes.SHOW_NEW_CARRIER,
      showNewCarrier: showNewCarrier
    }),
    onSetRole: (role) => dispatch({
      type: actionTypes.SET_ROLE,
      role: role
    }),
    onLogout: () => dispatch({ type: actionTypes.LOGOUT }),
    onRoutesUpdated: () => dispatch({ type: actionTypes.ROUTES_UPDATED }),
    onSetRequests: (requests) => dispatch({ type: actionTypes.REQUESTS, requests: requests }),
    onSetRoutes: (routes) => dispatch({ type: actionTypes.ROUTES, routes: routes }),
    onSetExternalNotifications: (externalNotifications) => dispatch({
      type: actionTypes.SET_EXTERNAL_NOTIFICATIONS,
      externalNotifications: externalNotifications
    }),
    onSetLocations: (locations) => dispatch({
      type: actionTypes.SET_LOCATIONS,
      locations: locations
    }),
    onSetTripCarrierHistory: (tripCarrierHistory) => dispatch({
      type: actionTypes.SET_TRIP_CARRIER_HISTORY,
      tripCarrierHistory: tripCarrierHistory
    }),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));



// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js